export const reducer = (state, action) => {
  switch (action.type) {
    case "REMOVE_FROM_WISHLIST":
      return {
        ...state,
        wishlist: state.wishlist.filter((p) => p.id !== action.payload.id),
      };
    case "ADD_TO_WISHLIST":
      return { ...state, wishlist: [{ ...action.payload }, ...state.wishlist] };
    case "CATEGORY_FILTER":
      const category = action.payload.category;
      return {
        ...state,
        brand: {
          ...state.brand,
          [category]: !state.brand[category],
        },
      };
    case "RATINGS_FILTER":
      const rating = action.payload.rating;
      return {
        ...state,
        ratings: {
          ...state.ratings,
          [rating]: !state.ratings[rating],
        },
      };
    case "PRICERANGE_FILTER":
      const priceRange = action.payload.priceRange;
      return {
        ...state,
        priceRange: {
          ...state.priceRange,
          [priceRange]: !state.priceRange[priceRange],
        },
      };
    default:
      return state;
  }
};
